import { render, staticRenderFns } from "./ProductFilterList.vue?vue&type=template&id=27c93df6"
import script from "./ProductFilterList.vue?vue&type=script&lang=ts"
export * from "./ProductFilterList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports